import React from 'react';
import './BulkUploadGuidelines.scss';

const BulkUploadGuidelines: React.FC = () => {
  const guidelines = [
    {
      title: "Name Field",
      description: "The Name field uniquely identifies each asset. If a file is available, enter its file name. If not, provide a clear and meaningful alternative. The system will either create or update assets based on the combination of Name and Division."
    },
    {
      title: "Excel Template Integrity",
      description: "Do not modify the Excel template structure. Avoid deleting columns or changing column headers, as this will cause the import process to fail."
    },
    {
      title: "Mandatory Fields",
      description: "Complete all mandatory fields marked in red in the Excel template. Leaving these fields empty will cause the import process to fail."
    },
    {
      title: "Column Order",
      description: "Do not rearrange columns in the Excel template. Altering the column order will lead to import failures."
    },
    {
      title: "File Naming Convention",
      description: "Ensure file names do not include special characters or spaces, as these may disrupt the import process."
    },
    {
      title: "Multi-select (Tabular) Fields",
      description: "Values for tabular (multi-select) fields should be separated using the \"|\" delimiter. These fields are marked in green in the Excel template."
    },
    {
      title: "Drop-down Fields",
      description: "Select values only from the provided drop-down lists for fields marked in silver in the Excel template. Failure to select a valid drop-down value will result in import errors."
    },
    {
      title: "Drop-down List Integrity",
      description: "Do not modify or add new values to the existing drop-down lists for the silver-marked fields. Any modifications will cause the import to fail."
    },
    {
      title: "Error Column",
      description: "Do not manually enter any data in the \"Error\" column. This column is automatically populated by the system to indicate issues during the import process."
    },
    {
      title: "Model ID Field",
      description: "Never change the value of the Model ID field. It uniquely identifies assets within the DAM system and must remain unchanged."
    }
  ];

  return (
    <div className="bulk-upload-guidelines">
      <h2 id="bulk-upload-guidelines" className="guidelines-title">
        Guidelines for Excel Template and Asset Import Process
      </h2>
      
      <div className="guidelines-container">
        <ol className="guidelines-list">
          {guidelines.map((guideline, index) => (
            <li key={index} className="guideline-item">
              <strong className="guideline-title">
                {guideline.title}
              </strong>
              <div className="guideline-description">
                • {guideline.description}
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default BulkUploadGuidelines;
